module.exports = __webpack_public_path__ + "static/media/live-scenes.ec2eabca.png";